import { format } from 'date-fns'

import { CURRENCY_DOTS, ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_FORMAT } from '../../config/settings/regexes'
import { checkOnlyLettersNumbersAndSomeSymbols } from './checkers'

/**
 * To decorate the given value to a number with a thousands separator.
 */
export const formatNumberWithThousandSeparator = value => value.toString().replace(CURRENCY_DOTS, '$1.')

export function generateFormatedDate(date) {
  return [padTo2Digits(date.getDate()), padTo2Digits(date.getMonth() + 1), date.getFullYear()].join('/')
}

function padTo2Digits(num) {
  return num.toString().padStart(2, '0')
}

export function formatDate(date) {
  return date.split(' ')[0].replaceAll('/', '-')
}

export function formatDateToDDMMYYYY(date) {
  if (!date) return ''
  return format(date, 'dd-MM-yyyy')
}

/**
 * Formats a given string value to only letters, numbers, and some symbols (._-,).
 */
export const formatOnlyLettersNumbersAndSomeSymbols = value =>
  checkOnlyLettersNumbersAndSomeSymbols(value) ? value : value.replace(ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_FORMAT, '')
